import { ChangeDetectionStrategy,Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AdminComponentBase } from 'app/layout/content';

import { WidgetUsageTimelineComponent } from './widget-usage-timeline.component';

@Component({
    templateUrl: './dashboards-overview-page.component.html',
    styleUrls: ['./dashboards-overview-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [WidgetUsageTimelineComponent]
})
export class DashboardsOverviewPageComponent extends AdminComponentBase implements OnInit, OnDestroy {
    private readonly route = inject(ActivatedRoute);

    storeId: string;

    ngOnInit(): void {
        this.registerSubscription(this.route.params.subscribe(params => {
            this.storeId = params.storeId;
        }));
    }

    ngOnDestroy(): void {
        this.unsubscribeSubscriptions();
    }
}
